const map = {
	"./aerobics-girl.png": 1279,
	"./alien.png": 1280,
	"./arcade-cabinet.png": 1281,
	"./aviator-glasses.png": 1282,
	"./boombox.png": 1283,
	"./cassette.png": 1284,
	"./delorean.png": 1285,
	"./electroguitar.png": 1286,
	"./elvis.png": 1287,
	"./floppy.png": 1288,
	"./ghost.png": 1289,
	"./hustler.png": 1290,
	"./joystick.png": 1291,
	"./officer.png": 1292,
	"./pc.png": 1293,
	"./pizza.png": 1294,
	"./player.png": 1295,
	"./rollers.png": 1296,
	"./skateboard.png": 1297,
	"./sneakers.png": 1298,
	"./synthesizer.png": 1299,
	"./telephone.png": 1300,
	"./tv.png": 1301,
	"./yuppie.png": 1302,
	"./zombie.png": 1303
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1278;